import { CoreError, CoreErrorCause } from '@domain/models/core-error'

function getErrorCode(error: Error): string | null {
  if ('code' in error && typeof error.code === 'string') {
    return error.code
  }
  return null
}

export class ImageErrorConverter {
  public static domainModel(fromExternalModel: unknown): CoreError {
    if (fromExternalModel instanceof CoreError) {
      return fromExternalModel
    }

    if (!(fromExternalModel instanceof Error)) {
      return new CoreError({
        cause: CoreErrorCause.Unknown,
        context: `An unknown image service error happened: ${String(fromExternalModel)}`,
        underlyingException: fromExternalModel,
      })
    }

    const code = getErrorCode(fromExternalModel)
    switch (code) {
      case 'storage/unauthorized':
        return new CoreError({
          cause: CoreErrorCause.PermissionDenied,
          context: 'Permission denied while uploading image.',
          underlyingException: fromExternalModel,
        })
      case 'storage/retry-limit-exceeded':
      case 'storage/canceled':
      case 'storage/unknown':
        return new CoreError({
          cause: CoreErrorCause.NetworkConnection,
          context: 'Image upload failed due to a network issue.',
          underlyingException: fromExternalModel,
        })
      default:
        return new CoreError({
          cause: CoreErrorCause.Unknown,
          context: fromExternalModel.message || 'Failed to process image upload.',
          underlyingException: fromExternalModel,
        })
    }
  }
}
